export enum DiscountModifier {
  PERCENTAGE = 'percentage',
  ABSOLUTE = 'absolute',
}

export enum DiscountType {
  PER_UNIT_AND_FLAT_DISCOUNT = 'PerUnitAndFlatDiscount',
  FLAT_DISCOUNT = 'FlatDiscount',
}

interface FlatPercentageDiscount {
  modifier: DiscountModifier.PERCENTAGE
  percentage: number
}

interface FlatAbsoluteDiscount {
  modifier: DiscountModifier.ABSOLUTE
  amount: {
    currency: string
    value: number
  }
}

export type FlatPlanDiscount = FlatPercentageDiscount | FlatAbsoluteDiscount

export interface CustomerPlanDiscount {
  type: DiscountType
  discount: FlatPlanDiscount
  expirationDate: string | undefined
}
